<div>
  <div class="row">
    <div class="small col-12 text-right">
      <label id="gridSize">表示サイズ : </label>
      <mat-radio-group for="gridSize" (change)="gridSizeChange()" [(ngModel)]="scope.gridSize" aria-label="表示サイズ">
        <mat-radio-button [value]="2">大</mat-radio-button>
        <mat-radio-button [value]="3">中</mat-radio-button>
        <mat-radio-button [value]="5">小</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div #videoContainer class="video-container" cdkDropListGroup>
        <div cdkDropList 
            [cdkDropListEnterPredicate]="dropListEnterPredicate" 
            (cdkDropListDropped)="dropListDropped($event)">
        </div>
        <div class="item" [style.width.px]="scope.itemWidth" [style.height.px]="scope.itemHeight" cdkDropList *ngFor="let item of scope.items"
            (click)="detail(item)"
            [cdkDropListEnterPredicate]="dropListEnterPredicate" 
            (cdkDropListDropped)="dropListDropped($event)">
          <div cdkDrag (cdkDragMoved)="dragMoved($event);" class="video-box">
            <div class="">
              <!-- Add the bg color to the header using any of the bg-* classes -->
              <div class="capture-back">
                <gs-capture id="{{ item.streamId }}" name="{{ item.streamName }}"></gs-capture>
              </div>
              <div class="video-footer">
                <div class="text-right">
                  <span class="title">{{ item.streamName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
  </div>
</div>
